import {AxiosResponse} from 'axios'
import Client from 'core/api/client'
import {IanaTimezone} from 'core/utils/timezone'
import authHeaders from './authHeaders'

interface IDeleteReviewerResponseBody {
  email: string
}

export interface IDeleteReviewerResponse extends AxiosResponse {
  data: IDeleteReviewerResponseBody
}

export function deleteReviewer(token: string, id: string): Promise<IDeleteReviewerResponse> {
  const url = `/study/reviewer/${id}`;
  return Client.delete(url, { ...authHeaders(token), validateStatus: () => true });
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/api/study_reviewer/deleteReviewer.ts